export enum EventosTipoEnum { ANSWER, PUSH, SIGNUP, REFERRAL, PRIZE_EXCHANGE, REFUND, SCORE_EXTRA,
    CHALLENGE_FINISHED, TODOS }

const idsEventosTipo = new Map<EventosTipoEnum, string>();
idsEventosTipo.set(EventosTipoEnum.ANSWER, "ANSWER");
idsEventosTipo.set(EventosTipoEnum.PUSH, "PUSH");
idsEventosTipo.set(EventosTipoEnum.SIGNUP, "SIGNUP");
idsEventosTipo.set(EventosTipoEnum.REFERRAL, "REFERRAL");
idsEventosTipo.set(EventosTipoEnum.PRIZE_EXCHANGE, "PRIZE_EXCHANGE");
idsEventosTipo.set(EventosTipoEnum.REFUND, "REFUND");
idsEventosTipo.set(EventosTipoEnum.SCORE_EXTRA, "SCORE_EXTRA");
idsEventosTipo.set(EventosTipoEnum.CHALLENGE_FINISHED, "CHALLENGE_FINISHED");
idsEventosTipo.set(EventosTipoEnum.TODOS, "TODOS");

const nombresEventosTipo = new Map<EventosTipoEnum, string>();
nombresEventosTipo.set(EventosTipoEnum.ANSWER, "Respuesta a combo");
nombresEventosTipo.set(EventosTipoEnum.PUSH, "Mensaje privado");
nombresEventosTipo.set(EventosTipoEnum.SIGNUP, "Registración");
nombresEventosTipo.set(EventosTipoEnum.REFERRAL, "Referido");
nombresEventosTipo.set(EventosTipoEnum.PRIZE_EXCHANGE, "Premio");
nombresEventosTipo.set(EventosTipoEnum.REFUND, "Reintegro");
nombresEventosTipo.set(EventosTipoEnum.SCORE_EXTRA, "Compensación");
nombresEventosTipo.set(EventosTipoEnum.CHALLENGE_FINISHED, "Desafío");
nombresEventosTipo.set(EventosTipoEnum.TODOS, "Todos");

export const obtenerIdEventoTipo = (evento: EventosTipoEnum): string => idsEventosTipo.get(evento) || "";
export const obtenerNombreEventoTipo = (evento: EventosTipoEnum): string => nombresEventosTipo.get(evento) || "";

export const obtenerNombresEventoTipo: () => Array<[EventosTipoEnum, string]> = () =>
    Array.from(nombresEventosTipo.entries());
